import axios from 'src/utils/baseAxios';

/**
 * Müşterinin email threadlerini listeler
 * @param {number} consumerId - Müşteri ID
 * @returns {Promise<Object>} Thread listesi response
 */
export const getThreadList = async (consumerId) => {
    try {
        const response = await axios.get(`/Email2Case/GetThreadList/${consumerId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching thread list:', error);
        throw error;
    }
};

/**
 * Belirli bir thread'in detaylarını ve mesajlarını getirir
 * @param {number} consumerId - Müşteri ID
 * @param {string} threadId - Thread ID
 * @param {number} workCaseId - Work Case ID
 * @param {number} workOrderId - Work Order ID
 * @returns {Promise<Object>} Thread detayları ve mesajlar
 */
export const getThreadDetails = async (consumerId, threadId, workCaseId, workOrderId) => {
    try {
        const response = await axios.get(`/Email2Case/GetThreadDetails/${consumerId}/${encodeURIComponent(threadId)}/${workCaseId}/${workOrderId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching thread details:', error);
        throw error;
    }
};

/**
 * Thread'e email yanıtı gönderir
 * @param {number} consumerId - Müşteri ID
 * @param {string} body - Email içeriği (HTML destekli)
 * @param {string} workOrderId - Work Order ID
 * @param {string} workCaseId - Work Case ID
 * @param {string} threadId - Thread ID
 * @param {string[]} to - Ek alıcılar (isteğe bağlı)
 * @param {string[]} cc - CC alıcıları (isteğe bağlı)
 * @returns {Promise<Object>} Response
 */
export const sendEmail = async (consumerId, body, workOrderId, workCaseId, threadId, to = [], cc = []) => {
    try {
        const response = await axios.post('/Email2Case/SendEmail', {
            ConsumerId: consumerId,
            Body: body,
            WorkOrderId: String(workOrderId),
            WorkCaseId: String(workCaseId),
            ThreadId: threadId,
            To: to,
            Cc: cc,
        });
        return response.data;
    } catch (error) {
        console.error('Error sending email:', error);
        throw error;
    }
};

export default {
    getThreadList,
    getThreadDetails,
    sendEmail,
};
